/*
 * @Copyright:
 * -----------------------------------------------------------------------------------
 *  Kingsoft Office Enterprise Cloud Services.
 *  Copyright (c) Kingsoft Office,All rights reserved.
 * -----------------------------------------------------------------------------------
 *
 * @Date: 2020-08-24 17:51:03
 * @Author: Kaven.D
 * @LastEditors: Kaven.D
 * @LastEditTime: 2020-09-22 17:30:54
 * @Description:
 */
import mutations from './mutations'
import actions from './actions'
import { isAdmin, isLogin, Account as ACCOUNT, superAdmin } from './constants'

export interface Account {
  account: string
  address: string
  city: string
  companyid: number
  country: string
  departmentid: string
  email: string
  firstname: string
  is_plus: boolean
  lastname: string
  loginmode: string
  nickname: string
  phonenumber: string
  pic: string
  postal: string
  province: string
  regtime: number
  result: string
  role: string[]
  sex: string
  status: string
  userid: number
  uzone: string
}

export interface UserState {
  USER_isAdmin: boolean
  USER_isLogin: boolean
  USER_Account: Account | null
  USER_superAdmin: string
}

export const createUserState = (): UserState => {
  return {
    [isAdmin]: true,
    [isLogin]: false,
    [ACCOUNT]: null,
    [superAdmin]: '',
  } as unknown as UserState
}

export default function () {
  return {
    state: createUserState(),
    actions,
    mutations,
    getters: {},
  }
}
